// extracted by mini-css-extract-plugin
export default {"avatar-group":"style_avatar-group__Kuj2Z","avatar-single":"style_avatar-single__FUB29"};